var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirtingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    viewBox: "8 10 64 60",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,15.8H40c0,0,0,0,0,0s0,0,0,0h-0.2c-3.1,0-5.7-0.3-6.9,0.2c1.9,3.6,6.9,9.4,7,9.8c0.1-0.5,5.1-6.2,7-9.8  C45.8,15.5,43.3,15.8,40.2,15.8z M61.6,19.5c-0.5-0.2-5.1-1.8-5.6-2c-5.9-2.6-6.3-6.7-8.7-7.2c-1.5-0.3-4.1-0.2-7.1-0.2h-0.2  c-3.1,0-5.6-0.1-7.1,0.1c-2.4,0.4-2.9,4.5-8.7,7.2c-0.5,0.2-5.1,1.8-5.6,2c-5.1,2.2-7.2,11.8-10.3,16.6c2.7,3,6.8,4.4,11.5,5.3  c0.6-0.8,2.6-7,2.7-5.9c2.7,11.3-1.5,26.6-2.7,30c1.6,2.6,10.6,4.1,18.9,4.2l1-3.8V26.2c-1.7-2-6.9-6.1-6.9-6.1l-11.2,0  c0,0,8.2-3.2,10.1-8c0,0.7,0.2,1.3,0.6,2.2c0-0.4,0-0.6,0-1c0.3-1.5,3.4-1,7.6-1H40c0,0,0,0,0,0s0,0,0,0h0.2c4.2,0,7.3-0.5,7.6,1  c0.1,0.3,0.1,0.6,0,1c0.4-1,0.6-1.6,0.6-2.2c1.9,4.8,10,8,10,8l-11.2,0c0,0-5.1,4.1-6.8,6.1V66l1,3.8c8.3-0.1,17.3-1.6,18.9-4.2  c-1.2-3.4-5.4-18.7-2.7-30c0.2-1.1,2.1,5,2.7,5.8c4.8-0.9,8.8-2.2,11.5-5.3C68.8,31.3,66.6,21.8,61.6,19.5z M38.2,26.9  c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1C37.2,27.3,37.7,26.9,38.2,26.9z M38.2,38.9c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1  c-0.5,0-1-0.4-1-1C37.2,39.3,37.7,38.9,38.2,38.9z M38.2,50.8c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9  C37.3,51.2,37.7,50.8,38.2,50.8z M38.2,62.8c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9  C37.3,63.2,37.7,62.8,38.2,62.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirtingIcon);
export default __webpack_public_path__ + "static/media/shirting-icon.1aed392c5e9ee1546cc3decb057386c2.svg";
export { ForwardRef as ReactComponent };